export const location = [
    {name: 'Berne', abbrev: 'BE'},
    {name: 'Genève', abbrev: 'JU'},
    {name: 'Jura', abbrev: 'JU'},
    {name: 'Valais', abbrev: 'VS'},
    {name: 'Vaud', abbrev: 'VD'},
];

